var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TrainingProcessLog',{attrs:{"extra-params":_vm.extraParams,"visible":_vm.visible,"extra-id":_vm.$attrs['extra-id'],"api-url":"/workspace/manager/training/rejoin/rejoinProcessLog","log-type-name":"答辩"}})
}
var staticRenderFns = []

export { render, staticRenderFns }